interface LemonPiLogoProps {
  className?: string;
}

const LemonPiLogo = ({ className }: LemonPiLogoProps) => (
  <img src="/lemon-pie-192.png" alt="" aria-hidden="true" className={className} />
);

export default LemonPiLogo;
